import {
    UOMO_ACCEPT_CALLBACK_URLS,
    UOMO_CONFIRM_COMPONENT,
    UOMO_DEFAULT_CALLBACK_URL,
    UOMO_EMAIL_DOMAINS,
    UOMO_LINKAGE_ID,
    UOMO_LINKAGE_NAME,
    UOMO_LOGIN_CUSTOM_COMPONENT,
    UOMO_PATH,
    UOMO_PROFILE_COMPONENT,
    UOMO_SERVICE_TERM_URL,
    UOMO_SITE_UNIQ_API_PATH
} from "@/commons/linkage/sites/uomo";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// UOMO画面用ルート定義
const routes = createLinkageRoute(
    UOMO_LINKAGE_ID,
    UOMO_LINKAGE_NAME,
    UOMO_PATH,
    UOMO_SITE_UNIQ_API_PATH,
    UOMO_DEFAULT_CALLBACK_URL,
    UOMO_ACCEPT_CALLBACK_URLS,
    UOMO_SERVICE_TERM_URL,
    UOMO_EMAIL_DOMAINS,
    UOMO_PROFILE_COMPONENT,
    UOMO_CONFIRM_COMPONENT,
    {
        loginCustomComponent: UOMO_LOGIN_CUSTOM_COMPONENT,
    }
);

// UOMO画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// UOMO画面用ルータ
export const uomoRouter = router;
